import React, { useState, useEffect, useMemo } from "react";
import Spreadsheet from "react-spreadsheet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as XLSX from 'xlsx';
import {
  faSearchPlus,
  faSearchMinus,
  faSyncAlt,
  faChevronDown,
  faChevronUp,
  faTable,
  faColumns,
  faDownload,
  faFileImport,
  faPlus,
  faMinus,
  faTrash,
  faPalette,
  faBrain,
  faSort,faExchangeAlt ,faSearch ,faArrowUp, faArrowDown
} from "@fortawesome/free-solid-svg-icons";
import "./tablenav.css";
import Papa from "papaparse";
import { useSetAtom, useAtomValue } from "jotai";
import { Button, InputGroup, FormControl } from 'react-bootstrap';
import {
  sheetData,
  airesponse,
  length,
  selectdata,
  insertDirectionAtom,
  rowIndexAtom,
  colIndexAtom,
  aiResponseColumnsAtom,tableNameAtom 
} from "../../Atoms";
import "./Cell.css";
export const TableNav = () => {
  const [keyword, setKeyword] = useState("");
const [isKeywordHighlightActive, setIsKeywordHighlightActive] = useState(false);



  const [showTable, setShowTable] = useState(false);
  const [rows, setRows] = useState(100);
  const [columns, setColumns] = useState(10);
  const [data, setData] = useState(createInitialData(100, 10));
  const [tableKey, setTableKey] = useState(0); // Key to force re-render
  const [sortColumn, setSortColumn] = useState(""); // Column name for sorting
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'
  const [zoomLevel, setZoomLevel] = useState(1); // Initial zoom level (1 = 100%)
  const [dropdownVisible, setDropdownVisible] = useState(false); // Toggle dropdown visibility
  // const [formattingDropdownVisible, setformattingDropdownVisible] = useState(false); // Toggle dropdown visibility
  const setSheetData = useSetAtom(sheetData);
  const setlength = useSetAtom(length);
  const [deleteInput, setDeleteInput] = useState("");
  const [deleteType, setDeleteType] = useState("row");
  const [isHovering, setIsHovering] = useState(false);
  const tableName = useAtomValue(tableNameAtom);
  const [isInputVisible, setIsInputVisible] = useState(false);
  // const aitext = useAtomValue(airesponse);
  const [showDeleteControls, setShowDeleteControls] = useState(false);
  const [selectedCell, setSelectedCell] = useState({
    row: null,
    col: null,
    selected: false,
  });
  const [showDuplicateOptions, setShowDuplicateOptions] = useState(false);

  const [backgroundColor, setBackgroundColor] = useState("ffffff");
  const [fontColor, setFontColor] = useState("000000");
  const [textStyle, setTextStyle] = useState("normal");
  const [formattingDropdownVisible, setFormattingDropdownVisible] =
    useState(false);
  const [rowOrColIndex, setRowOrColIndex] = useState(0); // Default index
  const [targetType, setTargetType] = useState("row"); // Either "row" or "column"
  const [formatType, setFormatType] = useState();
  const [selectionType, setSelectionType] = useState("row"); // 'row' or 'column'
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedIndices, setSelectedIndices] = useState("");
  const [selectDropdownVisible, setSelectDropdownVisible] = useState(false);
  const [dropdownVisibl, setDropdownVisibl] = useState(false);
  const setExtractedValues = useSetAtom(selectdata);
  const [selectAll, setSelectAll] = useState(false);
  const insertDirection = useAtomValue(insertDirectionAtom);
  const index = useAtomValue(rowIndexAtom);
  const aiResponseColumns = useAtomValue(aiResponseColumnsAtom);
  const [localInsertDirection, setLocalInsertDirection] = useState(null);
  const [localIndex, setLocalIndex] = useState(null);
  const [localAiResponseColumns, setLocalAiResponseColumns] = useState([]);
  const [isHighlightActive, setIsHighlightActive] = useState(false);
  function showNotification(message, duration = 3000) {
    const notification = document.createElement("div");
    notification.className = "notification";
    notification.innerText = message;

    document.body.appendChild(notification);

    // Show the notification
    setTimeout(() => {
      notification.classList.add("show");
    }, 10);

    // Hide the notification after the specified duration
    setTimeout(() => {
      notification.classList.remove("show");
      notification.classList.add("hide");

      // Remove the notification from the DOM after it's hidden
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 500);
    }, duration);
  }

  function createInitialData(rows, columns) {
    return Array.from({ length: rows }, () =>
      Array.from({ length: columns }, () => ({ value: "" }))
    );
  }
  const [fontSize, setFontSize] = useState(1); 
  const zoomIn = () => {
    setFontSize((prev) => Math.min(prev + 0.1, 2)); // Max font size multiplier
    showNotification("Zooming In");
  };

  // Function to zoom out
  const zoomOut = () => {
    setFontSize((prev) => Math.max(prev - 0.1, 0.5)); // Min font size multiplier
    showNotification("Zooming Out");
  };

  

  function zoomReset() {
    setFontSize(1); // Reset zoom level to 1
    showNotification("Resetting zoom");
  }

  function handleDataChange(newData) {
    setData(newData);
  }



  const handleDownload = () => {
    const csvFileName = `${tableName}.csv`; // Use the table name from Jotai

    // Convert your data to a CSV string
    const csvString = Papa.unparse(
      data.map((row) => row.map((cell) => cell.value))
    );

    // Create a Blob from the CSV string
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

    // Create a download link
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.setAttribute('download', csvFileName);

    // Append to body, trigger download, and remove the element
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Revoke the URL to release memory
    URL.revokeObjectURL(url);

    // Show a notification for user feedback
    if (typeof showNotification === 'function') {
      showNotification(`Downloading ${csvFileName}`);
    }
  };

  const handleShowInput = () => {
    setIsInputVisible(true);
  };
  function addRow() {
    setRows((prevRows) => {
      const newRows = prevRows + 100; // Increment row count by 100
  
      // Use functional update to add 100 new rows to the data
      setData((prevData) => {
        const newRowsData = Array.from({ length: 100 }, () => (
          Array.from({ length: columns }, () => ({ value: "" }))
        ));
        return [...prevData, ...newRowsData];
      });
  
      showNotification("100 Rows Added");
      return newRows;
    });
  }
  

  function addColumn() {
    setColumns((prevColumns) => {
      const newColumns = prevColumns + 10; // Increment column count by 10
  
      // Use functional update to add 10 new columns to each row
      setData((prevData) => {
        return prevData.map((row) => {
          const newColumnsData = Array.from({ length: 10 }, () => ({ value: "" }));
          return [...row, ...newColumnsData]; // Append new columns to the row
        });
      });
  
      showNotification("10 Columns Added");
      return newColumns;
    });
    // handleDataChange()
    // showNotification("Column Added");
  }

  async function handleFileImport(event) {
    const file = event.target.files[0];
    if (file) {
      // Clear existing data before importing a new file
      setData([]);
      setRows(100); // Default to 100 rows
      setColumns(10); // Default to 10 columns
      setShowTable(false);  // Hide the table before importing new data
      setTableKey((prevKey) => prevKey + 1); // Force table to fully reset
  
      // Determine file type
      const fileExtension = file.name.split('.').pop().toLowerCase();
  
      const padData = (data, minRows = 100, minCols = 10) => {
        const rows = data.length >= minRows ? data.length : minRows;
        const columns = data[0]?.length >= minCols ? data[0].length : minCols;
  
        // Ensure minimum rows
        const paddedData = [...data];
        while (paddedData.length < rows) {
          paddedData.push(new Array(columns).fill({ value: '' }));
        }
  
        // Ensure each row has a minimum number of columns
        for (let i = 0; i < paddedData.length; i++) {
          while (paddedData[i].length < columns) {
            paddedData[i].push({ value: '' });
          }
        }
        
        return paddedData;
      };
  
      try {
        if (fileExtension === 'csv') {
          const parseCSV = (file) => new Promise((resolve, reject) => {
            Papa.parse(file, {
              header: false,
              skipEmptyLines: true,
              dynamicTyping: true,
              complete: (result) => resolve(result.data),
              error: (error) => reject(error)
            });
          });
  
          let rows = await parseCSV(file);
  
          // Pad data to ensure at least 100 rows and 10 columns
          rows = padData(rows.map((row) => row.map((cell) => ({ value: cell }))));
  
          handleDataChange(rows);
          setRows(rows.length);
          setColumns(rows[0].length);
          setShowTable(true); // Show table after importing data
          setTableKey((prevKey) => prevKey + 1); // Force re-render
          showNotification("CSV File Imported Successfully");
  
        } else if (fileExtension === 'xlsx') {
          const reader = new FileReader();
  
          reader.onload = async (e) => {
            try {
              const arrayBuffer = e.target.result;
              const workbook = XLSX.read(arrayBuffer, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];
              let data = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });
  
              let formattedData = data.map((row) =>
                row.map((cell) => ({ value: cell }))
              );
  
              // Pad data to ensure at least 100 rows and 10 columns
              formattedData = padData(formattedData);
  
              handleDataChange(formattedData);
              console.log(data);
              
              setRows(formattedData.length);
              setColumns(formattedData[0].length);
              setShowTable(true); // Show table after importing data
              setTableKey((prevKey) => prevKey + 1); // Force re-render
              showNotification("Excel File Imported Successfully");
            } catch (error) {
              console.error("Error parsing XLSX file:", error.message);
              showNotification("Error importing Excel file");
            }
          };
  
          reader.readAsArrayBuffer(file);
        } else {
          showNotification("Unsupported file type. Please upload a CSV or XLSX file.");
        }
      } catch (error) {
        console.error("File import error:", error.message);
        showNotification("Error importing file");
      }
    }
  }
   
  

  function handleAddNewTable() {
    // Always clear existing data and reset the state when the function is called
    setData([]); // Clear existing data
    setRows(100); // Set default row count
    setColumns(10); // Set default column count
    setShowTable(true); // Show the table
    setTableKey((prevKey) => prevKey + 1); // Force re-render
    setData(createInitialData(100, 10)); // Set new initial data
  }
  
  

  function sortData(columnIndex, ascending) {
    const sortedData = [...data].sort((a, b) => {
      const valueA = a[columnIndex]?.value || "";
      const valueB = b[columnIndex]?.value || "";

      if (ascending) {
        return valueA.localeCompare(valueB, undefined, { numeric: true });
      } else {
        return valueB.localeCompare(valueA, undefined, { numeric: true });
      }
    });

    setData(sortedData);
    console.log("after sort", data);

    // Update state with all sorted data
    // setColumns(sortedData.length); // Update
    showNotification(
      `Sorting by ${sortColumn} in ${
        ascending ? "ascending" : "descending"
      } order`
    );
  }

  function handleSort() {
    const columnNames = getColumnNames(); // Get column names from your logic
    const columnIndex = columnNames.indexOf(sortColumn); // Find index of selected column

    if (columnIndex >= 0 && data.length > 0) {
      sortData(columnIndex, sortOrder === "asc");
      setDropdownVisible(false); // Hide dropdown after sorting
    }
  }

  function getColumnNames() {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return Array.from(
      { length: columns },
      (_, i) => letters[i] || `Column ${i + 1}`
    );
  }

  const applyFormattingToCe = (selectedCell, className) => {
    if (
      selectedCell &&
      selectedCell.row !== undefined &&
      selectedCell.col !== undefined
    ) {
      let tempRenderData = [...data];
      let cell = tempRenderData[selectedCell.row][selectedCell.col];

      if (cell) {
        // Apply all class names combined into one
        cell.className = className;

        console.log("Class name updated:", cell.className);

        handleDataChange(tempRenderData);
      }
    }
  };
  const formatValue = (value, formatType) => {
    // If formatType is 'none', remove any previous formatting and return the unformatted value
    if (formatType === "none") {
      let unformattedValue = value;

      // Remove percentage sign if it exists
      if (unformattedValue.includes("%")) {
        unformattedValue = unformattedValue.replace("%", "");
      }

      // Remove dollar sign if it exists
      if (unformattedValue.includes("$")) {
        unformattedValue = unformattedValue.replace("$", "");
      }

      // Parse and clean up if the value was previously formatted as a date
      const parsedDate = Date.parse(unformattedValue);
      if (!isNaN(parsedDate)) {
        const date = new Date(parsedDate);
        unformattedValue = `${
          date.getMonth() + 1
        }/${date.getDate()}/${date.getFullYear()}`;
      }

      return unformattedValue.trim(); // Return the cleaned value
    }

    // Apply new formatting based on formatType
    if (formatType === "currency") {
      return `$${parseFloat(value).toFixed(2)}`;
    } else if (formatType === "percentage") {
      return `${parseFloat(value).toFixed(2)}%`;
    } else if (formatType === "date") {
      // Assuming value is a date string or timestamp
      const date = new Date(value);
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }

    // Default: return the value as is if no valid formatType is applied
    return value;
  };

  const applyFormattingToRow = (rowIndex, className, formatType) => {
    let tempRenderData = [...data];
  
    tempRenderData[rowIndex] = tempRenderData[rowIndex].map((cell) => {
      // Ensure cell.value is not null or undefined
      const formattedValue = formatValue(cell.value, formatType);
      return {
        ...cell,
        className: className,
        value: formattedValue,
      };
    });
  
    handleDataChange(tempRenderData);
  };
  const applyFormattingToCel= (selectedCell, className) => {
    if (!selectedCell || typeof selectedCell.row === 'undefined' || typeof selectedCell.col === 'undefined') {
      console.error("Invalid selectedCell: Make sure row and col are provided");
      return;
    }
  
    let tempRenderData = [...data]; // Make a copy of the data array
    const { row: rowIndex, col: colIndex } = selectedCell; // Destructure selected row and column indices
  
    // Ensure rowIndex and colIndex are within valid bounds
    if (
      rowIndex >= 0 &&
      rowIndex < tempRenderData.length && // Ensure row index is valid
      colIndex >= 0 &&
      colIndex < tempRenderData[rowIndex].length // Ensure column index is valid
    ) {
      const formattedValue = formatValue(tempRenderData[rowIndex][colIndex]?.value, formatType);
      // Update the className at the specific cell (rowIndex, colIndex)
      tempRenderData[rowIndex][colIndex] = {
        ...tempRenderData[rowIndex][colIndex],
        className: className, // Apply the className to the cell
        value: formattedValue,
      };
    } else {
      console.error("Invalid row or column index");
    }
  
    handleDataChange(tempRenderData); // Update the state with the modified data
  };







  const applyFormattingToColumn = (colIndex, className, formatType) => {
    let tempRenderData = [...data];
  
    tempRenderData = tempRenderData.map((row) => {
      if (colIndex >= 0 && colIndex < row.length) {
        const formattedValue = formatValue(row[colIndex]?.value, formatType); // Safely access value
        row[colIndex] = {
          ...row[colIndex],
          className: className,
          value: formattedValue,
        };
      }
      return row;
    });
  
    handleDataChange(tempRenderData);
  };
  
  const handleApplyFormatting = () => {
    console.log("Selected Cell: ", selectedCell);
    
    const combinedClassName = [
      `bg-${backgroundColor}`,
      `text-${fontColor}`,
      `font-${textStyle}`,
    ]
      .join(" ")
      .trim();
      // alert(formatType)
    // if (selectedCell && selectedCell.row >= 0 && selectedCell.col >= 0) {
      applyFormattingToRange(selectedRange, combinedClassName,formatType);
      showNotification("Formatting applied to the selected cell");
    // } else {
    //   showNotification("Please select a valid cell to apply formatting");
    // }
  };

  useEffect(() => {
    setLocalInsertDirection(insertDirection);
    setLocalIndex(index);
    setLocalAiResponseColumns(aiResponseColumns);
  }, [insertDirection, index, aiResponseColumns]);
  // console.log("🚀 ~ useEffect ~ aiResponseColumns:", aiResponseColumns);

  useEffect(() => {
    if (
      localInsertDirection &&
      localIndex !== null &&
      Array.isArray(localAiResponseColumns)
    ) {
      let newData = [...data]; // Copy the existing data array
  
      if (localInsertDirection === "row") {
        // Check if the row index is within the current bounds
        if (localIndex >= newData.length) {
          alert("Click on add row then add in sheet");
          return;
        }
  
        // Initialize the target row if it does not exist
        while (newData.length <= localIndex) {
          newData.push(new Array(newData[0].length).fill({ value: "" }));
        }
  
        // Populate the target row with data from localAiResponseColumns
        localAiResponseColumns.forEach((currElement, columnIndex) => {
          newData[localIndex][columnIndex] = { value: `${currElement}` };
        });
  
        handleDataChange(newData);
      }
  
      if (localInsertDirection === "column") {
        // Ensure every row has enough columns to accommodate the new column index
        newData.forEach((row, rowIndex) => {
          while (row.length <= localIndex) {
            row.push({ value: "" });
          }
        });
  
        // Populate the new column data across rows with values from localAiResponseColumns
        localAiResponseColumns.forEach((currElement, rowIndex) => {
          if (!newData[rowIndex]) {
            newData[rowIndex] = new Array(newData[0].length).fill({ value: "" });
          }
          newData[rowIndex][localIndex] = { value: `${currElement}` };
        });
  
        handleDataChange(newData);
      }
    }
  }, [localInsertDirection, localIndex, localAiResponseColumns]);
  

  // Reset variables after insertion
  useEffect(() => {
    if (localInsertDirection && localIndex !== null && localAiResponseColumns) {
      setLocalInsertDirection(null);
      setLocalIndex(null);
      setLocalAiResponseColumns(null);
    }
  }, [data]); // Triggered when data updates
console.log('data',data)
  const selectCell = useMemo(() => selectedCell, [selectedCell]);
  // highlightKeywordCells(selectCell)
//  console.log(selectedCell,"selectedCell");
 
  // Function to handle cell deselection
  const selectedData = useMemo(() => {
    if (
      data &&
      selectCell &&
      selectCell.row !== undefined &&
      selectCell.col !== undefined
    ) {
      return data[selectCell.row]?.[selectCell.col] || null;
    }
    return null;
  }, [data, selectCell]);

  //   return null;
  // }
  // Function to handle cell selection
  useEffect(() => {
    if (selectedCell?.selected) {
      // console.log("Selected Data:", selectedData);
    } else {
      console.log(null);
    }
  }, [selectedData, selectedCell?.selected]);

  setSheetData(data); // Update atom value

  const handleUpdateData = (aitext) => {
    // console.log("Current data:", data);
    // console.log("AI text to update:", aitext);

    // Update data using prevData to ensure it adds the new column with AI text properly
    setData((prevData) => {
      const updatedData = prevData.map((row, i) => [
        ...row,
        { value: aitext[i] || "None" }, // Append AI text to each row
      ]);
      return updatedData; // Return the new updated data
    });
  };


  // Function to flatten the data before rendering
  const cloneDeep = (obj) => {
    return JSON.parse(JSON.stringify(obj));
  };

  // Deep clone the data
  const handleRowSelect = (rowIndex) => {
    const rowValues = extractRowValues(rowIndex);
    // console.log("Row Values:", rowValues);

    const combinedClassName = [
      `bg-${backgroundColor}`,
      `text-${fontColor}`,
      `font-${textStyle}`,
    ]
      .join(" ")
      .trim();

    applyFormattingToRow(rowIndex, combinedClassName, formatType);
  };

  const handleColumnSelect = (colIndex) => {
    const columnValues = extractColumnValues(colIndex);
    // console.log("Column Values:", columnValues);

    const combinedClassName = [
      `bg-${backgroundColor}`,
      `text-${fontColor}`,
      `font-${textStyle}`,
    ]
      .join(" ")
      .trim();

    applyFormattingToColumn(colIndex, combinedClassName, formatType);
  };
  const handleActivate = (e) => {
    const { row, column, type } = e;
    setSelectedCell({ row, col: column });

    // debugger
    if (type === "cell") {
      // console.log('celll',selectedCell);
      setSelectedCell({ row, col: column });
      
      
      
    } else if (type === "rowHeader") {
      handleRowSelect(selectCell.row);
    } else if (type === "colHeader") {
      handleColumnSelect(selectCell.col);
    }
  };

  const extractRowValues = (rowIndex) => {
    // console.log(`Extracting row at index: ${rowIndex}`); // Log the row index
  
    if (Array.isArray(data) && rowIndex >= 0 && rowIndex < data.length) {
      const row = data[rowIndex];
      
      // console.log('Row data:', row); // Log the row being processed
  
      if (row && typeof row === "object") {
        const values = Object.values(row).flat(); // Extract and flatten values
        // console.log('Extracted values:', values); // Log the extracted values before mapping
  
        const finalValues = values.map((cell) => cell || ""); // Map values, replace falsy values
        // console.log('Final row values:', finalValues); // Log the final result after processing
  
        return finalValues; // Return the processed row values
      }
    }
    
    // console.log('Invalid row index or data, returning empty array.'); // Log if invalid
    return [];
  };
  
  function handleDelete() {
    const index = parseInt(deleteInput, 10) - 1; // Convert input to zero-based index
    
    if (deleteType === "row") {
      if (index >= 0 && index < data.length) {
        setData((prevData) => {
          const newData = prevData.filter((_, i) => i !== index);
          return newData;
        });
        setRows((prevRows) => prevRows - 1);
        showNotification("Row Deleted");
      } else {
        showNotification("Invalid Row Number");
      }
    } else if (deleteType === "column") {
      if (index >= 0 && data.length > 0 && index < data[0].length) {
        setData((prevData) => {
          const newData = prevData.map((row) =>
            row.filter((_, i) => i !== index)
        );
        return newData;
      });
      setColumns((prevColumns) => prevColumns - 1);
      showNotification("Column Deleted");
    } else {
      showNotification("Invalid Column Number");
    }
  }
}

// Function to toggle dropdown visibility
const toggleSelectDropdown = () => {
  setSelectDropdownVisible((prev) => !prev);
};




































// Function to toggle sort dropdown visibility

const extractColumnValues = (colIndex) => {
  if (Array.isArray(data)) {
    const columnValues = [];
    data.forEach((row) => {
      if (typeof row === "object") {
        const values = Object.values(row).flat(); // Get and flatten the values of the object
        if (colIndex >= 0 && colIndex < values.length) {
          // Directly access the value at the colIndex
          columnValues.push(values[colIndex] || ""); // Use the value or default to an empty string
        }
      }
    });
    // console.log('extracttttttt', columnValues);
    return columnValues;
  }
  return [];
};


const handleExtractValues = () => {
  const indices = selectAll
  ? selectionType === "row"
        ? Array.from(Array(data.length).keys())
        : Array.from(Array(data[0]?.length || 0).keys())
      : selectedIndices.split("/").map((index) => parseInt(index.trim(), 10));

    const extractedValues = [];
    // console.log('hello',Json.stringify(extractedValues));

    if (selectionType === "row") {
      indices.forEach((index) => {
        const values = extractRowValues(index);
        extractedValues.push({ type: "row", index, values });
      });
    } else if (selectionType === "column") {
      indices.forEach((index) => {
        const values = extractColumnValues(index);
        extractedValues.push({ type: "column", index, values });
      });
    }
    showNotification('Data Extracted')
    // alert(extractedValues)
    // Update the atom with the extracted values
    setExtractedValues(extractedValues);
  };
// useEffect(() => {
//   if (showTable) {
//     handleExtractValues();
//   }
// }, [showTable, data]);



const handleRemoveExtractedValues = () => {
  setExtractedValues([]); // Clear the extracted values
  setSelectedIndices(''); // Optional: Clear the selected indices input
  showNotification('Extracted values cleared'); // Optional: Show a notification
};























const handleDeleteDuplicates = () => {
  let tempRenderData = [...data];
  setIsKeywordHighlightActive(false);
  let seenRows = new Set();
  let uniqueRows = [];
  let emptyRows = []; // Store empty rows separately
  let deletedRowsCount = 0; // Track number of rows deleted

  tempRenderData.forEach((row) => {
    const isEmptyRow = row.every(cell => !cell || !cell.value || !cell.value.trim()); // Check if all cells in the row are empty or null

    if (isEmptyRow) {
      // If the row is empty, add it to the emptyRows array
      emptyRows.push(row);
    } else {
      const rowString = row.map(cell => (cell.value || '').trim()).join('|'); // Create a unique string for comparison
      if (!seenRows.has(rowString)) {
        seenRows.add(rowString);
        uniqueRows.push(row);
      } else {
        deletedRowsCount++; // Increment count of deleted rows
      }
    }
  });

  // Combine unique rows with empty rows
  const finalData = [...uniqueRows, ...emptyRows];

  // Update the state with unique rows and preserved empty rows
  setData(finalData);
  // console.log(`Deleted ${deletedRowsCount} duplicate rows.`);
};



// Toggle the visibility of the duplicate options
const toggleDuplicateOptions = () => {
  setShowDuplicateOptions(prevState => !prevState);
};







const highlightKeywordCells = () => {
  let tempData = [...data];

  if (isKeywordHighlightActive) {
    // Remove existing keyword highlights
    tempData = tempData.map(row =>
      row.map(cell => {
        if (cell && typeof cell.className === "string") {
          return {
            ...cell,
            className: cell.className.replace("highlight-keyword", "")
          };
        }
        return cell; // Return cell as is if className is not a string
      })
    );
    setIsKeywordHighlightActive(false);
    showNotification("Search removed");
  } else {
    // Apply keyword highlighting
    tempData = tempData.map(row =>
      row.map(cell => {
        if (cell && typeof cell.value === "string") {
          return {
            ...cell,
            className: cell.value.includes(keyword) ? "highlight-keyword" : (cell.className || "")
          };
        }
        return cell; // Return cell as is if value is not a string
      })
    );
    setIsKeywordHighlightActive(true);
    showNotification("Applied");
  }

  setData(tempData); // Update state after highlighting
};
const handleKeywordChange = (event) => {
  setKeyword(event.target.value); // Update the keyword state with the new value
};

const handleSelect = (selection) => {
  // Log the selection to understand its structure
  // console.log('Selection:', selection);

  // Check if selection and its range properties exist
  if (!selection || !selection.range || !selection.range.start || !selection.range.end) {
    console.error('Invalid selection object:', selection);
    return; // Exit if the selection is invalid
  }

  const { start, end } = selection.range; // Access start and end through the range

  // Store the selected range in a state variable
  const _selectedRange = {
    startRow: start.row,
    endRow: end.row,
    startCol: start.column,
    endCol: end.column,
  };
  setSelectedRange(_selectedRange);
  // console.log(`Selected range from Row ${start.row}, Column ${start.column} to Row ${end.row}, Column ${end.column}`);

};
const [selectedRange, setSelectedRange] = useState(null);
const applyFormattingToRange = (range, className, formatType) => {
  // console.log('Applying formatting to range:', range);

  let tempRenderData = [...data]; // Make a copy of the data array
  
  // Loop through the selected range and apply formatting
  for (let row = range.startRow; row <= range.endRow; row++) {
    for (let col = range.startCol; col <= range.endCol; col++) {
      // Ensure row and column indices are within valid bounds
      if (
        row >= 0 &&
        row < tempRenderData.length && // Ensure row index is valid
        col >= 0 &&
        col < tempRenderData[row].length // Ensure column index is valid
      ) {
        // Access the current cell
        const currentCell = tempRenderData[row][col];

        // Format the value if it exists and apply the className
        const formattedValue = formatValue(currentCell?.value, formatType); // Safely access value
        // alert(formatType)
        // Update the current cell with the formatted value and class name
        tempRenderData[row][col] = {
          ...currentCell,
          className: className,
           // Apply the className directly to the cell
          value: formattedValue, // Set the formatted value
        };
      } else {
        console.error("Invalid row or column index in range:", row, col);
      }
    }
  }

  // Update the state with the modified data
  handleDataChange(tempRenderData); 
};


const [foundCells, setFoundCells] = useState([]); // Store found cells with row/col indices
const [currentSelection, setCurrentSelection] = useState(0); // Track which match is currently selected

// Handle search function to find and highlight the cells
const renderCells = () => {
  return data.map((row, rowIndex) => (
    <div key={rowIndex} className="row">
      {row.map((cell, colIndex) => {
        const isFound = foundCells.some(found => found.row === rowIndex && found.col === colIndex);
        const isSelected = currentSelection === foundCells.findIndex(found => found.row === rowIndex && found.col === colIndex);

        // Combine classes based on conditions
        const cellClass = `
          ${isFound ? 'highlight-keyword' : ''}
          ${isSelected ? 'selected-cell' : ''}
        `;

        return (
          <div
            key={colIndex}
            className={cellClass}
            onClick={() => setSelectedCell({ row: rowIndex, col: colIndex })} // Allow clicking to select a cell
          >
            {cell.value} {/* Display the cell value */}
          </div>
        );
      })}
    </div>
  ));
};
const [isSearching, setIsSearching] = useState(false); 


const handleSearch = () => {
  const keywordLower = keyword.toLowerCase();
  const tempData = [...data]; // Make a copy of the original data
  const matches = [];

  if (isSearching) {
    // If already searching, remove search highlights and reset selected cell
    tempData.forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        tempData[rowIndex][colIndex] = {
          ...cell,
          className: '', // Reset the className for all cells
        };
      });
    });
    setSelectedCell({ row: null, col: null }); // Reset selected cell
    setFoundCells([]); // Clear found cells
    setCurrentSelection(0); // Reset current selection
    setIsSearching(false); // Mark search as inactive
    showNotification('Search removed'); // Show notification
    handleDataChange(tempData); // Update the state with the modified data
    return; // Exit the function
  }

  // Reset all cell highlights before searching
  tempData.forEach((row, rowIndex) => {
    row.forEach((cell, colIndex) => {
      tempData[rowIndex][colIndex] = {
        ...cell,
        className: '', // Reset the className for all cells
      };
    });
  });

  // Find matches based on the search keyword
  tempData.forEach((row, rowIndex) => {
    row.forEach((cell, colIndex) => {
      if (typeof cell.value === 'string' && cell.value.toLowerCase().includes(keywordLower)) {
        matches.push({ row: rowIndex, col: colIndex });
        tempData[rowIndex][colIndex] = {
          ...cell,
          className: 'highlight-yellow', // Apply yellow highlight to matched cells
        };
      }
    });
  });

  setFoundCells(matches);
  setCurrentSelection(0);
  setData(tempData);

  // Handle the first search case
  if (matches.length > 0) {
    const { row, col } = matches[0];
    setSelectedCell({ row, col });
    applyFormattingToCell({ row, col }); // Highlight the first found cell
    // console.log(`Selected cell after search: Row ${row}, Col ${col}`);
    showNotification(`${matches.length} results found`);
    setIsSearching(true); // Mark search as active
  } else {
    // No matches found, reset selected cell and highlights
    setSelectedCell({ row: null, col: null });
    handleDataChange(tempData); // Ensure the data is updated to reflect no highlights
    showNotification('No results found');
  }
};

// Function to toggle the search/remove button
const toggleSearchButtonLabel = () => {
  return isSearching ? '' : '';
};
const navigateResults = (direction) => {
  if (!foundCells.length) return;

  const nextIndex = direction === "down" 
    ? (currentSelection + 1) % foundCells.length 
    : (currentSelection - 1 + foundCells.length) % foundCells.length;

  setCurrentSelection(nextIndex);
  const { row, col } = foundCells[nextIndex];
  setSelectedCell({ row, col });
  
  // Apply formatting to the newly selected cell
  applyFormattingToCell({ row, col });
};

// Function to apply formatting
const applyFormattingToCell = (selectedCell) => {
  if (!selectedCell || typeof selectedCell.row === 'undefined' || typeof selectedCell.col === 'undefined') {
    console.error("Invalid selectedCell: Make sure row and col are provided");
    return;
  }

  let tempRenderData = [...data]; // Make a copy of the data array
  const { row: rowIndex, col: colIndex } = selectedCell; 
  if (
    rowIndex >= 0 &&
    rowIndex < tempRenderData.length && // Ensure row index is valid
    colIndex >= 0 &&
    colIndex < tempRenderData[rowIndex].length 
  ) {
    // Reset all cell highlights before applying the selected one
    tempRenderData.forEach((row, rIndex) => {
      row.forEach((cell, cIndex) => {
        tempRenderData[rIndex][cIndex] = {
          ...cell,
          className: rIndex === rowIndex && cIndex === colIndex ? 'highlight-orange' : '', // Apply orange highlight to the selected cell
        };
      });
    });

    handleDataChange(tempRenderData); // Update the state with the modified data
  } else {
    console.error("Invalid row or column index");
  }
};

// JSX for displaying the selected cell
<p>Selected Cell: Row {selectedCell.row}, Column {selectedCell.col}</p>





  return (
    <>
    <div className="main_header">
      <div className="table-nav-header tbl_hdr_respo">
            <div className="table-nav-header-item">
              <button className="btnnn" onClick={handleAddNewTable}>
                <span>+ Empty Sheet</span>
              </button>
            </div>
          
            <div className="table-nav-header-item">
        {/* selectedCell = {JSON.stringify(selectedCell)} */}
              <FontAwesomeIcon icon={faTable} onClick={addRow} className="table-nav-icon" title="Rows"/>
              <span onClick={addRow}>100 Row</span>
              <div className="row-adjust-buttons">
                <button className="btnnn" onClick={addRow}title="Add Rows">
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              </div>
            </div>
            <div className="table-nav-header-item">
              <FontAwesomeIcon onClick={addColumn} icon={faColumns} className="table-nav-icon"title="Columns" />
              <span onClick={addColumn}>10 Col</span>
              <div className="column-adjust-buttons">
                <button className="btnnn" onClick={addColumn}title="Add Column">
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              </div>
            </div>

            <div className="table-nav-header-item">
              <button
                className="btnnn"
                onClick={() => setFormattingDropdownVisible((prev) => !prev)}
              >
                <FontAwesomeIcon icon={faPalette} className="table-nav-icon" title="Formatting Panel"/>
              </button>

              <div
                className={`formatting-controls ${
                  formattingDropdownVisible ? "show" : ""
                }`}
              >
                <div className="formatting-option">
                  <label>Background Color:</label>
                  <select
                    className="color-select"
                    onChange={(e) => setBackgroundColor(e.target.value.slice(1))}
                  >
                    <option value="#ffffff">White</option>
                    <option value="#ff0000">Red</option>
                    <option value="#00ff00">Green</option>
                    <option value="#0000ff">Blue</option>
                    <option value="#ffff00">Yellow</option>
                    <option value="#ff00ff">Magenta</option>
                    <option value="#00ffff">Cyan</option>
                    {/* <option value="#000000">Black</option> */}
                    <option value="#ffa500">Orange</option>
                    <option value="#808080">Gray</option>
                  </select>
                </div>

                {/* Font Color */}
                <div className="formatting-option">
                  <label>Font Color:</label>
                  <select
                    className="color-select"
                    onChange={(e) => setFontColor(e.target.value.slice(1))}
                  >
                    <option value="black">Black</option>
                    <option value="#ffffff">White</option>
                    <option value="#ff0000">Red</option>
                    <option value="#00ff00">Green</option>
                    <option value="#0000ff">Blue</option>
                    <option value="#ffff00">Yellow</option>
                    <option value="#ff00ff">Magenta</option>
                    <option value="#00ffff">Cyan</option>
                    <option value="#ffa500">Orange</option>
                    <option value="#808080">Gray</option>
                  </select>
                </div>

                {/* Text Style */}
                <div className="formatting-option">
                  <label>Text Style:</label>
                  <select
                    className="text-style-select"
                    onChange={(e) => setTextStyle(e.target.value)}
                  >
                    <option value="normal">Normal</option>
                    <option value="bold">Bold</option>
                    <option value="italic">Italic</option>
                    <option value="bold-italic">Bold & Italic</option>
                  </select>
                </div>

                {/* Type Selection */}
                <div className="formatting-option">
                  <label>Select Type:</label>
                  <select
                    className="text-style-select"
                    onChange={(e) => setFormatType(e.target.value)}
                  >
                    <option value="None">None</option>
                    <option value="date">Date</option>
                    <option value="currency">Currency</option>
                    <option value="percentage">Percentage</option>
                  </select>
                </div>
                {/* Row/Column Input */}
              

                <button onClick={handleApplyFormatting}>Apply Formatting</button>
              </div>
            </div>

            <div className="table-nav-header-item">
              <label htmlFor="fileInput" className="import-file-label">
                <span></span>
                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  accept=".csv, .xlsx"
                  onChange={handleFileImport}
                />
                <FontAwesomeIcon icon={faFileImport} className="table-nav-icon" title="Import File"/>
              </label>
            </div>
            <div className="table-nav-header-item">
              <button
                className="btnnn"
                onClick={() => setDropdownVisible((prev) => !prev)}
              >
                <FontAwesomeIcon icon={faSort} className="table-nav-icon" title="Sortting Panel" />
              </button>
              <div className={`sort-controls ${dropdownVisible ? "show" : ""}`}>
                <input
                  type="text"
                  placeholder="Column name to sort by"
                  value={sortColumn}
                  onChange={(e) => setSortColumn(e.target.value)}
                  list="column-names"
                />
                <datalist id="column-names">
                  {getColumnNames().map((name, index) => (
                    <option key={index} value={name} />
                  ))}
                </datalist>
                <select
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value)}
                >
                  <option value="asc">Ascending</option>
                  <option value="desc">Descending</option>
                </select>
                <button onClick={handleSort}>Apply Sort</button>
              </div>
            </div>
            <div className="table-nav-header-item" onClick={handleDownload} title="Download File">
          <FontAwesomeIcon icon={faDownload} className="table-nav-icon" />
            </div>
            <div className="table-nav-header-item">
              <button
                className="btnnn"
                onClick={() => setShowDeleteControls((prev) => !prev)}
              >
                <FontAwesomeIcon
                  icon={faTrash}
                  className="table-nav-icon del_icon"title="Delete Panel"
                />
              </button>
              {showDeleteControls && (
      <div className="delete-controls">
        <input
          type="text"
          placeholder={`Enter ${deleteType} number to delete`}
          value={deleteInput}
          onChange={(e) => setDeleteInput(e.target.value)}
        />
        <select
          value={deleteType}
          onChange={(e) => setDeleteType(e.target.value)}
        >
          <option value="row">Row</option>
          <option value="column">Column</option>
        </select>
        <button onClick={handleDelete} className="deletebutton">
          Delete
        </button>
      </div>
    )}
            </div>
            <button className="btnnn" onClick={zoomIn}>
              <FontAwesomeIcon icon={faSearchPlus}title="Zoom In" />
            </button>

            <button className="btnnn" onClick={zoomOut}>
              <FontAwesomeIcon icon={faSearchMinus} title="Zoom Out" />
            </button>

            <button className="btnnn" onClick={zoomReset}>
              <FontAwesomeIcon icon={faSyncAlt} title="Zoom Reset"/>
            </button>
            <div className="table-nav-header-item"onClick={toggleDuplicateOptions}>
      
            <FontAwesomeIcon icon={faSearch } title="Search And Delete Duplicates" />
            {showDuplicateOptions && (
              <div className="duplicate-controls">
                    <input
                      type="text"
                      placeholder="Search Keywords"
                      value={keyword}
                      onChange={handleKeywordChange}
                    />
                    <button onClick={highlightKeywordCells}>
                      {isKeywordHighlightActive ? "Remove Highlight" : "Highlight Keyword"}
                    </button>
                    <button onClick={handleDeleteDuplicates}>Delete Duplicates Rows</button>
              </div>
            )}
            </div>
            <div className="table-nav-header-item">
              <div
                className={`selection-controls ${
                  selectDropdownVisible ? "show" : ""
                }`}
              >
                <label>Select Type:</label>
                <select
                  className="color-select"
                  value={selectionType}
                  onChange={(e) => setSelectionType(e.target.value)}
                >
                  <option value="row">Row</option>
                  <option value="column">Column</option>
                </select>
                <br />
                <label>Indices (separated by '/'): </label>
                <input
                  type="text"
                  value={selectedIndices}
                  onChange={(e) => setSelectedIndices(e.target.value)}
                  placeholder="Enter indices..."
                />

                <label className="in">
                  Select All
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={(e) => setSelectAll(e.target.checked)}
                    className="inp"
                  />
                </label>
                <button onClick={handleExtractValues}>Extract Values</button>
                <button onClick={handleRemoveExtractedValues}>Remove Extracted</button>
              </div>
              <button
                className="btnnn"
                onClick={toggleSelectDropdown} // Toggle select dropdown visibility
              >
                <FontAwesomeIcon icon={faBrain} className="table-nav-icon" title="Values Extraction Panel" />
              </button>
              <p>{selectionType}:{selectedIndices}</p>
            </div>

      </div>

      <div className="search">
        <div className="search_input">
          <input
            type="text"
            placeholder="Search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            className="inpu"
            />
        </div>
        <div className="search_input_icons">

          <div onClick={() => navigateResults("up")} className=" inp_icons">
            <FontAwesomeIcon icon={faChevronUp} title="Up" />
          </div>
          <div onClick={() => navigateResults("down")} className=" inp_icons">
            <FontAwesomeIcon icon={faChevronDown} title="Down" />
          </div>
          <div className=" inp_icons inp_sr_icon"onClick={handleSearch}>{toggleSearchButtonLabel()}
            <FontAwesomeIcon icon={faSearch} title="Search" />
          </div>
        </div>
    
  
      </div>
    </div>
      <div>
      {showTable && (
            <div className="table-container">
              <div
              style={{
                fontSize: `${fontSize}em`, 
                transition: 'font-size 0.4s ease',
              }}
                >
                <Spreadsheet
                  data={data}
                  onChange={handleDataChange}
                  onActivate={handleActivate}
                  onSelect={(selection) => handleSelect(selection)}
                />
              </div>
              <div className="bt">
                <button className="add-row-button" onClick={addRow}>
                  <FontAwesomeIcon icon={faPlus} />
                  Add Row
                </button>
                <button className="add-column-button" onClick={addColumn}>
                  <FontAwesomeIcon icon={faPlus} />
                  Add Column
                </button>
              </div>
            </div>
          )}
      </div>
    </>

  );
};

export default TableNav;
